"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaPoliticalInstitute = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
const Card_1 = require("../Card");
const Turmoil_1 = require("../../turmoil/Turmoil");
class LunaPoliticalInstitute extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.LUNA_POLITICAL_INSTITUTE,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.EARTH],
            cost: 6,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.MOON, 2)),
            metadata: {
                description: 'Requires that you have 2 Moon tags.',
                cardNumber: 'M71',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Move one of your delegates from the reserve to any party.', (eb) => eb.empty().startAction.delegates(1));
                }),
            },
        });
    }
    ;
    play() {
        return undefined;
    }
    canAct(player) {
        return Turmoil_1.Turmoil.getTurmoil(player.game).hasAvailableDelegates(player.id);
    }
    action(player) {
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send a delegate', { source: 'reserve' }));
        return undefined;
    }
}
exports.LunaPoliticalInstitute = LunaPoliticalInstitute;
//# sourceMappingURL=LunaPoliticalInstitute.js.map